module.exports = __webpack_public_path__ + "static/media/ST6-BG3.fbb9360b.jpg";